<ul ngbNav #nav="ngbNav" [(activeId)]="ActiveId" (activeIdChange)="activeIdChange()" class="nav-tabs">
  <li ngbNavItem="Taskboard" *ngIf="!environment.RmaAddOn['hideTaskboard']" >
    <a ngbNavLink> {{'Taskboard'|translate}} </a>
    <ng-template ngbNavContent>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body p-t-0 p-b-0">
              <div class="row">
                <div class="col-lg-2">
                  <div class="form-group">
                    <label for="inizio" class="control-label col-form-label">Inizio</label>
                    <input id="inizio" required [(ngModel)]="inizio" (ngModelChange)="refresh()" class="form-control" type="date">
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label for="fine" class="control-label col-form-label">Fine</label>
                    <input id="fine" required [(ngModel)]="fine" (ngModelChange)="refresh()" class="form-control" type="date">
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="control-label col-form-label">Responsabile</label>
                    <ng-multiselect-dropdown required [settings]="utentidropdownSettings" [placeholder]="'Seleziona'" name="manager"
                                             [data]="managers" [(ngModel)]="managerselezionati"  (onFilterChange)="filtroResponsabile($event)" (ngModelChange)="refresh()">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label class="control-label col-form-label">Cliente</label>
                    <ng-multiselect-dropdown [settings]="clientidropdownSettings" [placeholder]="'Scadenza.cliente' | translate" id="cliente" [data]="clienti"
                                             [(ngModel)]="clientiselezionati" (onFilterChange)="filtroCliente($event)" (ngModelChange)="filtroProdotti()" >
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-lg-4" *ngIf="prodotti?.length >0">
                  <label for="manager" class="control-label col-form-label">Prodotto</label>
                  <ng-multiselect-dropdown [settings]="prodottidropdownSettings" [placeholder]="'Scadenza.prodotto' | translate" id="prodotto" [data]="prodotti"
                                           [(ngModel)]="prodottiselezionati" (onFilterChange)="filtroProdotti($event)" (ngModelChange)="refresh()">
                  </ng-multiselect-dropdown>
                </div>
                <div class="col-lg-2" *ngIf="environment.RmaAddOn['hideChiuso']">
                  <div class="form-group">
                    <label class="control-label col-form-label">Chiuso</label>
                    <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Chiuso' | translate" id="chiuso" [data]="[{id: true, label:'Chiuso'}, {id: false, label:'Non Chiuso'}]"
                                             [(ngModel)]="closedf" (ngModelChange)="refresh()" >
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label class="control-label col-form-label">Tipo</label>
                    <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Tipo' | translate" id="chiuso" [data]="tipi"
                                             [(ngModel)]="tipoObject" (ngModelChange)="refresh()" >
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-lg-2" *ngIf="environment.RmaAddOn['approvato']">
                  <div class="form-group">
                    <label class="control-label col-form-label">Approvato</label>
                    <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Approvato' | translate" id="chiuso" [data]="[{id: true, label:'Approvato'}, {id: false, label:'Non Approvato'}]"
                                             [(ngModel)]="Approvato" (ngModelChange)="refresh()" >
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <div class="d-md-flex align-items-center bg-white">

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="overflow-x: scroll;">
        <div class="card-body"  cdkDropListGroup>
          <div class="d-md-flex align-items-center bg-white">
            <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
            <div class=" mt-3 mb-3 mt-md-0">
              <button class="btn btn-outline-primary" (click)="Edit()"> Aggiungi </button>
            </div>
            <div class=" mt-3 mb-3 mt-md-0">
              <button class="btn btn-outline-primary" (click)="LeggiMail()"> Leggi Mail </button>
            </div>
          </div>
          <div class="taskboard page-height p-0" >
            <div class="taskboard-wrapper">
              <div class="taskboard-list" cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="List">
                <h7 class="taskboard-header font-weight-bold mt-2" >Attività</h7>
                <div class="taskboard-cards" >
                  <div class="taskboard-task cursor-pointer" cdkDrag *ngFor="let item of List" [ngStyle]="{'background-color': 'rgba(255, 255, 255, 0.1)'}">
                    <div class="taskboard-task-title font-medium">{{ item.nome }}</div>
                    <!--<div class="taskboard-task-title ">{{ GetShortText(item.note) }}</div>-->
                    <small class="card-text text-muted">{{item?.data_fine_prevista?(item?.data_fine_prevista | date: 'dd/MM/yyyy HH:mm'): (item?.data_inizio_prevista | date: 'dd/MM/yyyy HH:mm')}}</small>
                    <div class="mt-2 d-flex justify-content-start align-items-center">
                      <a href="javascript:void(0)" class="link" (click)="Edit(item)">
                        <i class="fas fa-eye"></i>
                      </a>
                      &nbsp;
                      <a href="javascript:void(0)" class="link" (click)="Delete(item)">
                        <i class="fas fa-trash-alt"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngFor="let item of InterventiTecnici"  class="taskboard-wrapper">
              <div class="taskboard-list" cdkDropList (cdkDropListDropped)="drop($event,item)" [cdkDropListData]="item.interventi" >
                <span class="taskboard-header font-weight-bold mt-2">{{item.tecnico}}</span>
                <div class="taskboard-cards" >
                  <div class="taskboard-task cursor-pointer" [ngbTooltip]="GetShortText(intervento.note)"  cdkDrag  *ngFor="let intervento of item.interventi"  [style.background-color]="intervento.chiuso?'rgba(0, 151, 0, 0.2)' : 'rgba(151,143,0,0.27)'">
                    <div class="taskboard-task-title font-small">{{ intervento.nome }}</div>
                    <small *ngIf="intervento.data_fine_prevista"  class="card-text text-muted">{{intervento.data_fine_prevista | date: 'dd/MM/yyyy HH:mm'}}</small>
                    <small *ngIf="!intervento.data_fine_prevista"  class="card-text text-muted">{{intervento.data_inizio_prevista | date: 'dd/MM/yyyy HH:mm'}}</small>
                    <div class="mt-2 d-flex justify-content-start align-items-center" >
                      <a href="javascript:void(0)" class="link"  (click)="Edit(intervento)">
                        <i class="fas fa-eye"></i>
                      </a>
                      &nbsp;
                      <a href="javascript:void(0)" class="link" (click)="Delete(intervento)">
                        <i class="fas fa-trash-alt"></i>
                      </a>
                      <!-- <a href="javascript:void(0)" class="text-danger ml-2" (click)="deleteTask(todo.id)">
                        <i-feather name="trash-2" class="feather-xs"></i-feather>
                      </a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </li>
  <li ngbNavItem="Lista" >
    <a ngbNavLink> {{'Lista'|translate}} </a>
    <ng-template ngbNavContent>
      <app-attivita-lista></app-attivita-lista>
    </ng-template>
  </li>
  <li ngbNavItem="gantt" *ngIf="environment.RmaAddOn['Gantt']">
    <a ngbNavLink> {{'Gantt'|translate}} </a>
    <ng-template ngbNavContent>
      <app-attivita-gantt></app-attivita-gantt>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>

